"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Use the existing performance API on web
exports.default = performance;
